// import React from "react";
// import Spinner from "../../../assets/images/Loading-v2.gif";
// export default function Loading({className=""}) {
//   return (
//     <div className={`loadingDiv ${className}`}>
//       <img className="loadingPng" src={Spinner} alt="Loading..." />
//     </div>
//   );
// }
import React from "react";
import Spinner from "../../../assets/images/Loading-v2.gif";

export default function Loading({ className = "", fullScreen = false, overlay = false }) {
  const modifierClass = fullScreen
    ? "loadingDiv--fullScreen"
    : overlay
    ? "loadingDiv--overlay"
    : "";
  return (
    <div className={["loadingDiv", modifierClass, className].filter(Boolean).join(" ")}>
      <img className="loadingPng" src={Spinner} alt="Loading..." />
    </div>
  );
}
